import React, { useState,useEffect } from "react";
import styles from "./Navbar.module.scss";
import Dropdown from "../Dropdown/Dropdown";
import { Link, useNavigate } from "react-router-dom";
const DesktopNavbar = () => {

 const navigate = useNavigate();


  const handleNavigation = (route) => {  
    navigate(route); // Navigate to the specified route
  };
 

  return (
    <nav className={styles.navbar}>
      <div className={styles.topbar}>
        <div className={styles.contactInfo}>
          <span>sales@sealkloud.com</span>
          <span>+91-9963500366</span>
        </div>
      </div>
      <div className={styles.container}>
        {/* Logo */}
        <div className={styles.logo} onClick={()=>handleNavigation('/')}>
          <img src="/assests/sealkloudlogo.png" alt="Logo" />
        </div>
       
        {/* Navigation Links */}
        <ul
          className={`${styles.navLinks}`}
        >
          <li className={styles.navItem}>
            <Link to="/">Home </Link>
          </li>
          {/* Dropdown Component */}
          <Dropdown data={dropdownData} name={"Solutions"} handleNavigation={handleNavigation} route={'/solutions'}/>
          <li className={styles.navItem}>
            <Link to="/services">Services</Link>
          </li>
          <li className={styles.navItem}>
            <Link to="/platforms">Platforms</Link>
          </li>
          <li className={styles.navItem}>
            <Link to="/aboutus">About Us</Link>
          </li>
          <li className={styles.navItem}>
            <Link to="/contact">Contact</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};
const MobileNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSolutionsDropdownOpen, setIsSolutionsDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleSolutionsDropdown = () => {
    setIsSolutionsDropdownOpen(!isSolutionsDropdownOpen);
  };

  const handleNavigation = (route) => {
    console.log(route);
    
    navigate(route); // Navigate to the specified route
    setIsMenuOpen(false); // Close the drawer on navigation
  };

  return (
    <>
      {/* Hamburger Icon */}
      <div className={styles.mobileNavbarHamburger} >
        <div onClick={toggleMenu}>☰</div> <div className={styles.mobileNavbarHamburgerIcon}>
          <img src="/assests/sealkloudlogo.png" alt="Logo" />
          </div>
      </div>
    
      {/* Drawer */}
      <div className={`${styles.mobileNavbarDrawer} ${isMenuOpen ? styles.open : ''}`}>
        {/* Logo Inside Drawer */}
        <div className={styles.mobileNavbarLogo} onClick={() => alert('/')}>
        <img src="/assests/sealkloudlogo.png" alt="Logo" />
        </div>

        {/* Close Icon */}
        <div className={styles.mobileNavbarCloseIcon
          
        } onClick={toggleMenu}>
          ✖
        </div>

        {/* Navigation Links */}
        <ul className={styles.mobileNavbarLinks}>
        <li>
            <Link to="/" onClick={() => handleNavigation('/')}>Home</Link>
          </li>
         
          <li>
            <Link to="/services" onClick={() => handleNavigation('/services')}>Services</Link>
          </li>

          {/* Solutions Dropdown */}
          <li className={styles.mobileNavbarDropdown}>
            <div
              className={`${styles.mobileNavbarDropdownToggle} ${
                isSolutionsDropdownOpen ? styles.open : ''
              }`}
              onClick={toggleSolutionsDropdown}
            >
              Solutions ▾
            </div>
            {isSolutionsDropdownOpen && (
              <ul className={styles.mobileNavbarSubmenu} onClick={()=>setIsMenuOpen(false) }>
                <li>
                  <strong>Services</strong>
                  <ul className={styles.mobileNavbarSubsubmenu}>
                    <li>
                      <Link to="/solutions/SAP S-4 Hana Conversion" >
                        SAP S/4 Hana Conversion
                      </Link>
                    </li>
                    <li>
                      <Link to="/solutions/SAP Application Support (SAP AMS)">
                        SAP Application Support (SAP AMS)
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>SAP S/4HANA</strong>
                  <ul className={styles.mobileNavbarSubsubmenu}>
                    <li>
                      <Link to="/solutions/RISE with SAP">
                        RISE with SAP
                      </Link>
                    </li>
                    <li>
                      <Link to="/solutions/SAP S-4Hana Cloud">
                        SAP S/4Hana Cloud
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Industrial Solutions</strong>
                  <ul className={styles.mobileNavbarSubsubmenu}>
                    <li>
                      <Link to="/solutions/SAP S-4HANA Retail">
                        SAP S/4Hana Retail
                      </Link>
                    </li>
                    <li>
                      <Link to="/solutions/SAP S-4HANA Fashion Vertical Business (FMS)" >
                        SAP S/4Hana Fashion Vertical Business (FMS)
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <strong>Omnichannel</strong>
                  <ul className={styles.mobileNavbarSubsubmenu}>
                    <li>
                      <Link to="/solutions/SAP CAR">
                      SAP CAR
                      </Link>
                    </li>
                    <li>
                      <Link to="/solutions/SAP CAR POSDTA" >
                      SAP CAR POSDTA
                      </Link>
                    </li>
                    <li>
                      <Link to="/solutions/SAP CAR OAA" >
                      SAP CAR OAA
                      </Link>
                    </li>
                    <li>
                      <Link to="/solutions/SAP CAR OPP" >
                      SAP CAR OPP
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <strong>SAP Forecast and Planning</strong>
                  <ul className={styles.mobileNavbarSubsubmenu}>
                    <li>
                      <Link to="/solutions/SAP Forecast and Replenishment (F&R)">
                      SAP Forecast and Replenishment (F&R)
                      </Link>
                    </li>
                    <li>
                      <Link to="/solutions/Unified Demand Forecast (UDF)" >
                      Unified Demand Forecast (UDF)
                      </Link>
                    </li>
                    <li>
                      <Link to="/solutions/SAP Demand Data Foundation (DDF)" >
                      SAP Demand Data Foundation (DDF)
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <strong>SAP Logistics Solutions</strong>
                  <ul className={styles.mobileNavbarSubsubmenu}>
                    <li>
                      <Link to="/solutions/SAP Customer Service (SAP CS)">
                      SAP Customer Service (SAP CS)
                      </Link>
                    </li>
                    <li>
                      <Link to="/solutions/SAP Sales and Distribution (SAP SD)" >
                      SAP Sales and Distribution (SAP SD)
                      </Link>
                    </li>
                    <li>
                      <Link to="/solutions/SAP Material Management (SAP MM)" >
                      SAP Material Management (SAP MM)
                      </Link>
                    </li>
                    <li>
                      <Link to="/solutions/SAP Advanced Available-to-Promise (aATP)" >
                      SAP Advanced Available-to-Promise (aATP)
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Technical Solutions</strong>
                  <ul className={styles.mobileNavbarSubsubmenu}>
                    <li>
                      <Link to="/solutions/SAP Business Technology Platform (SAP BTP)">
                      SAP Business Technology Platform (SAP BTP)
                      </Link>
                    </li>
                    <li>
                      <Link to="/solutions/SAP FIORI" >
                      SAP FIORI
                      </Link>
                    </li>
                    <li>
                      <Link to="/solutions/SAP ABAP" >
                      SAP ABAP
                      </Link>
                    </li>
                    <li>
                      <Link to="/solutions/SAP BASIS" >
                      SAP BASIS
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            )}
          </li>
          <li>
            <Link to="/platforms" onClick={() => handleNavigation('/platforms')}>Platforms</Link>
          </li>
          <li>
            <Link to="/aboutus" onClick={() => handleNavigation('/aboutus')}>About Us</Link>
          </li>
          <li>
            <Link to="/contact" onClick={() => handleNavigation('/contact')}>Contact</Link>
          </li>
        </ul>

        {/* Demo Request Button */}
        <div className={styles.mobileNavbarDemoRequest}>
          <button onClick={() => handleNavigation('/contact')}>Demo Request</button>
        </div>
      </div>
    </>
  );
};


const Navbar = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {isMobile ? <MobileNavbar /> : <DesktopNavbar />}
    </>
  );
};

export default Navbar;


const dropdownData = [
  ["Services", "SAP S/4 Hana Conversion", "SAP Application Support (SAP AMS)"],
  ["SAP S/4Hana", "RISE with SAP", "SAP S/4Hana Cloud"],
  [
    "Industrial Solutions",
    "SAP S/4HANA Retail",
    "SAP S/4HANA Fashion Vertical Business (FMS)",
  ],
  ["Omnichannel", "SAP CAR", "SAP CAR POSDTA", "SAP CAR OAA", "SAP CAR OPP"],
  [
    "SAP Forecast and Planning",
    "SAP Forecast and Replenishment (F&R)",
    "Unified Demand Forecast (UDF)",
    "SAP Demand Data Foundation (DDF)",
  ],
  ["SAP Logistics Solutions",
    "SAP Customer Service (SAP CS)",
    "SAP Sales and Distribution (SAP SD)",
    "SAP Material Management (SAP MM)",
    "SAP Advanced Available-to-Promise (aATP)"],
  [
    "Technical Solutions",
    "SAP Business Technology Platform (SAP BTP)",
    "SAP FIORI",
    "SAP ABAP",
    "SAP BASIS",
  ],
];